import script from "./GlassLoaderTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GlassLoaderTable.vue?vue&type=script&setup=true&lang=js"

import "./GlassLoaderTable.vue?vue&type=style&index=0&id=25a3b692&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a3b692"]])

export default __exports__